// extracted by mini-css-extract-plugin
export default {"carousel":"styles_carousel__sRiEj","carousel_inner":"styles_carousel_inner__cUpt5","scroll":"styles_scroll__2CZM4","image":"styles_image__dATMS"};